import { SxProps, Stack, CircularProgress } from '@mui/material'

interface IBoxLoadingProps {
  sx?: SxProps
  isShow?: boolean
}
const BoxLoading = (props: IBoxLoadingProps) => {
  const { sx, isShow } = props
  if (!isShow) return null

  return (
    <Stack
      sx={{
        position: 'absolute',
        transform: 'translate(-50%, -50%)',
        left: '50%',
        top: '50%',
        ...sx,
      }}
    >
      <CircularProgress />
    </Stack>
  )
}
export default BoxLoading
